import { useBannerOrBlocker } from "./useBannerOrBlocker.js";
function useLegalLinks() {
    const { links = [], websiteOperator } = useBannerOrBlocker();
    const validLinks = links.filter((param)=>{
        let { label, url } = param;
        return label && url;
    });
    const privacyPolicy = validLinks.find((param)=>{
        let { pageType } = param;
        return pageType === "privacyPolicy";
    });
    const legalNotice = validLinks.find((param)=>{
        let { pageType } = param;
        return pageType === "legalNotice";
    });
    return {
        privacyPolicy: privacyPolicy ? {
            url: privacyPolicy.url,
            label: privacyPolicy.label
        } : false,
        legalNotice: legalNotice ? {
            url: legalNotice.url,
            label: legalNotice.label
        } : false,
        contactForm: (websiteOperator == null ? void 0 : websiteOperator.contactFormUrl) || undefined
    };
}
export { useLegalLinks };
